import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import TitleBaseMeta from '../Title/UI/TitleBaseMeta';
import TitleJacketImage from '../Title/UI/TitleJacketImage';
import LaneContainer from '../UI/LaneContainer';
import TitleActions from './TitleActions';
import TitleActivitySummary from './TitleActivitySummary';
import './titleActivityTile.css';
import TitleReviewBursts from './TitleReviewBursts';
import { Popover } from 'antd';
import ParseContent from '../ParseContent';

export class TitleActivityTile extends React.Component {
	constructor(props) {
		super(props);
		this.selectTitle = this.selectTitle.bind(this);
		this.state = {
			selectedTitles: [],
		};
	}

	render() {
		const {
			request,
			download,
			review,
			title,
			isSelected,
			titleListType,
		} = this.props;
		const isMobile = this.props.isMobile();
		return (
			<div className="relative">
				{title.product && (
					<LaneContainer>
						<div className="main-title-container">
							<div className="left-title-content">
								<div className="tile-jacket">
									<TitleJacketImage
										product={title.product}
										height={135}
									/>
									<TitleReviewBursts
										reviews={title.product.reviews}
										rating={title.product.average}
									/>
									{title.product.markupNotes && (
										<div className="markupTriangle">
											<Popover
												trigger="click"
												placement="bottomRight"
												content={
													<ParseContent
														content={
															title.product
																.markupNotes[0]
																.value
														}
													/>
												}>
												<div className="markupNoteIcon icon-note-icon"></div>
											</Popover>
										</div>
									)}
								</div>
							</div>
							<div className="center-title-content">
								<div>
									<TitleBaseMeta
										product={title.product}
										format="simple"
										communityId={0}
									/>
								</div>
							</div>
							{!isMobile && (
								<div className="right-title-content">
									<TitleActivitySummary
										request={request}
										download={download}
										review={review}
									/>
								</div>
							)}
							<TitleActions
								request={request}
								download={download}
								review={review}
								title={title}
								selectTitle={this.selectTitle}
								isSelected={isSelected}
								positionBottomRight={true}
							/>
							{titleListType &&
								titleListType.key === 'catalog' && (
									<div className="list-number-frame">
										{title.product.sequence + 1}
									</div>
								)}
						</div>
						<div className="clear" />
					</LaneContainer>
				)}
			</div>
		);
	}

	selectTitle = (sku, isSelected) => {
		this.props.logSelectedTitles(sku, isSelected);
	};
}

export default withIsMobile(TitleActivityTile);
